import { type ReactNode, useEffect } from 'react';
import { getPingWaitInterval, getTimedWaitInterval, isLaterThan } from '../utils/date';

/** Wait component to display to display a message when the flow is set to wait */
const Wait = ({
    children,
    waitExpiresAt,
    join,
    ping,
    isPageWait,
}: {
    children?: ReactNode;
    waitExpiresAt: string | null;
    join: () => void;
    ping: () => Promise<boolean>;
    isPageWait: boolean | null;
}) => {
    useEffect(() => {
        const intervalTime = waitExpiresAt ? getTimedWaitInterval() : getPingWaitInterval();

        const isDone = () => {
            if (waitExpiresAt !== null) {
                return Promise.resolve(isLaterThan(waitExpiresAt));
            }
            return ping();
        };

        const interval = setInterval(() => {
            isDone().then((done) => {
                if (done) {
                    clearInterval(interval);
                    join();
                }
            });
        }, intervalTime);

        return () => {
            clearInterval(interval);
        };
    }, [waitExpiresAt, join, ping]);

    if (isPageWait) {
        return null;
    }

    return (
        <div className="wait-content">
            <span className="loader-lg" />
            {children}
        </div>
    );
};

export default Wait;
